// OperationCSVUpload
export type DraftCsvUploadResultZeus = {
  id: number;
  createdAt: string;
  updatedAt: string;
  lastUpdateUserId: string;
  adAccountId: number;
  fileName: string;
  draftFileUrl: string;
  errorFileUrl: string;
  uploadUserId: string;
  uploadAt: string;
  processingCompletionTime: string;
  fileRecordCount: number;
  checkOkCount: number;
  checkNgCount: number;
  status: number;
}

export const ImmunityMessage: string[] = [
  "※各種操作欄が未記入の場合は新規登録・更新されませんので、予めご注意ください",
  "※機種依存文字はCSVファイル保存時に「?」へ置換される場合がございます。この場合、新規登録・更新内容も「?」となりますのでご注意ください",
];